<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
    <p>{{ data.message }}</p>
    <p></p>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 20px;" >
    <button mat-button class="btn-cancel" (click)="closeModal()"> {{ 'COMMON_BTN_CLOSE' | translate }} </button>
</mat-dialog-actions>